import React from 'react'
import {
  Wrapper,
  LogoWrapper,
  ContentWrapper,
  LeftContentSection,
  RightContentSection,
  ContentButton,
  ClosedHM,
  Heading
} from './StoreErrorPageStyledComponents'
import Logo from '../../components/layout/Logo/Logo'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router-dom'

const StoreNotFound = React.memo(({ response, history }) => (
  <Wrapper>
    <LogoWrapper>
      <Logo />
    </LogoWrapper>
    <ContentWrapper>
      <LeftContentSection>
        <div>
          <Heading>
            <FormattedMessage id='storeErrorPage.notAvailable' />
          </Heading>
          <span>
            {response}
          </span>
        </div>
        <ClosedHM />
      </LeftContentSection>
      <RightContentSection>
        <span>
          <FormattedMessage id='storeErrorPage.setupNewHausmart' />
        </span>
        <ContentButton
          color='secondary'
          onClick={() => {
            window.open('https://hausmart.app.link/', '_blank')
          }}
        >
          <FormattedMessage id='storeErrorPage.createStore' />
        </ContentButton>
        <span>
          <FormattedMessage id='general.or' />
        </span>
        <ContentButton color='primary' onClick={() => history.push('/')}>
          <FormattedMessage id='storeErrorPage.goBackToHausmart' />
        </ContentButton>
      </RightContentSection>
    </ContentWrapper>
    <div />
    <div />
  </Wrapper>
))

StoreNotFound.displayName = 'StoreNotFound'

StoreNotFound.propTypes = {
  response: PropTypes.string.isRequired,
  history: PropTypes.object
}

export default withRouter(StoreNotFound)
